<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-slide-toggle
	[hideIcon]="true"
	[checked]="checked"
	[disabled]="disabled"
	(change)="handleToggleChange.emit($event.checked)"
>
	<ng-content />
</mat-slide-toggle>
